module.exports = {"ronda-1":"Ronda 1","ronda-2":"Ronda 2","ronda-3":"Ronda 3","instrucciones":"Instrucciones"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locals/instructions/es.json
// module id = 183
// module chunks = 2